module.exports = __webpack_public_path__ + "img/1586468325.cd2ae31a.jpg";